import { render, staticRenderFns } from "./LogoBanner.vue?vue&type=template&id=7069ceb6"
import script from "./LogoBanner.vue?vue&type=script&lang=js"
export * from "./LogoBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports